import React from 'react';
import { Quote } from 'lucide-react';
import { testimonials } from '../mock/mock';

export default function Testimonials() {
  return (
    <div className="grid gap-6 md:grid-cols-3">
      {testimonials.map((t) => (
        <div key={t.name} className="reveal glass rounded-2xl p-7 flex flex-col">
          <Quote size={30} className="text-[#2563eb]/50 mb-4" />
          <p className="text-slate-700 leading-relaxed flex-1">“{t.quote}”</p>
          <div className="mt-6 flex items-center gap-3">
            <img src={t.img} alt={t.name} className="w-11 h-11 rounded-full object-cover border border-slate-200" />
            <div>
              <div className="font-semibold text-slate-900 text-sm">{t.name}</div>
              <div className="text-xs text-slate-500">{t.title}</div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
